import { createApp } from 'vue'
import permission from '@/directive/permission'
import InfiniteScroll from '@/directive/infiniteScroll'

export default (app: ReturnType<typeof createApp>) => {
  // directive
  app.use(permission)
  app.directive('InfiniteScroll', InfiniteScroll)
}
